<template>
  <div class="balance-transactions">
    <bp-table-header :total="pagination.count" @refresh="refresh">
      <bp-date-picker v-model="dates" @input="refresh" slot="date-picker" />
      <bp-export-button
        slot="buttons"
        action="financial/exportTransactions"
        filename="transactions"
        :filters="getFilters"
      />
    </bp-table-header>

    <bp-data-table
      :loading="loading"
      :columns="columns"
      :data="transactions"
      class="my-6"
    >
      <template #saldo="{value,item}">
        <div
          class="d-flex functional-1 gap-3"
          :class="formatClass(value, item)"
        >
          <bp-icon :icon="getIcon(item)" />
          {{ value }}
        </div>
      </template>
    </bp-data-table>

    <bp-paginator
      v-model="page"
      :pagination="pagination"
      @change-page="dispatch"
    />
  </div>
</template>
<script>
import { clearObject, formatMoney } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

const negativeStatusTypes = [
  "reversal",
  "conciliation",
  "withdraw",
  "tax_anticipation",
  "tax_withdraw",
  "tax",
  "chargeback"
];
function isNegative(item) {
  return negativeStatusTypes.includes(item.type);
}

export default {
  data() {
    return {
      loading: false,
      columns: [
        {
          name: "Data",
          field: "created_at",
          transform: this.formatDate
        },
        {
          name: "ID transação",
          field: "id"
        },
        {
          name: "Produto",
          field: "product_name",
          size: "1.5fr"
        },
        {
          name: "Valor",
          field: "amount",
          class: this.formatClass,
          transform: this.formatAmount
        },
        {
          name: "Tipo de transação",
          field: "type",
          class: this.formatClass,
          transform: this.formatType
        },
        {
          name: "Saldo",
          field: "balance",
          class: this.formatClass,
          transform: v => `R$ ${formatMoney(v)}`
        }
      ],
      pagination: {},
      dates: ["", ""],
      page: 1
    };
  },
  computed: {
    ...mapState("financial", ["transactions"])
  },
  methods: {
    formatDate(val) {
      return moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    formatClass(_, item) {
      if (item.type == "waiting") return "text-alert-600";
      return isNegative(item) ? "text-negative-600" : "text-positive-600";
    },
    formatAmount(val, item) {
      let prefix = "";
      if (item.status != "waiting") {
        prefix = isNegative(item) ? "-" : "+";
        return `${prefix}R$ ${formatMoney(val)}`;
      }
    },
    formatType(val) {
      return (
        {
          reversal: "Estorno",
          conciliation: "Conciliação de Saldo",
          withdraw: "Saque",
          tax_anticipation: "Taxa por antecipação",
          tax_withdraw: "Taxa de saque",
          tax: "Cobrança de juros",
          waiting: "Aguardando liberação",
          chargeback: "Chargeback",
          reward: "Comissão de indicação"
        }[val] || "Comissão de venda"
      );
    },
    getIcon(item) {
      if (item.status === "waiting") return "fa-light fa-clock";
      if (item.status === "reward") return "fa-regular fa-bullhorn";
      return isNegative(item) ? "fa-light fa-down" : "fa-light fa-up";
    },

    getFilters() {
      const filters = {};
      if (this.dates[0] && this.dates[1]) {
        Object.assign(filters, {
          created_at_after: this.dates[0],
          created_at_before: this.dates[1]
        });
      }
      return filters;
    },
    setPagination(data) {
      let { count, next, previous } = data;
      this.pagination = { count, next, previous };
    },
    dispatch(offset = 0) {
      this.loading = true;
      this.$store
        .dispatch(
          "financial/getTransactions",
          clearObject({
            offset,
            ...this.getFilters()
          })
        )
        .then(this.setPagination)
        .finally(() => (this.loading = false));
    },
    refresh() {
      this.page = 1;
      this.dispatch();
    }
  },
  mounted() {
    this.dispatch();
  }
};
</script>
